import {setLocalData, getLocalData} from "./StorageServices";

const _keyStore = 'auth';
const _initState = {
    accessToken: '',
    user: {}
};

const _store = {
    state: getLocalData(_keyStore, _initState),
    listeners: []
};

const _broadcast = () => {
    const {listeners, state} = _store;

    listeners.forEach(listener => {
        typeof listener === 'function' && listener(state);
    });
};

export const addAuthListener = (listener) => {
    if (typeof listener !== 'function') {
        return;
    }

    const {listeners} = _store;

    if (listeners.indexOf(listener) !== -1) {
        return;
    }

    _store.listeners = [].concat(listeners, listener);
};

export const removeAuthListener = (listener) => {
    _store.listeners = _store.listeners.filter(_listener => listener !== _listener);
};

export const getAuthState = () => {
    return {
        ..._store.state
    };
};

export const isAuthenticated = () => {
    const {state} = _store;

    return !!state.accessToken;
};

export const getAccessToken = () => {
    const {state} = _store;

    return state.accessToken || '';
};

export const logout = () => {
    return setAuthState(_initState);
};

export const setAuthState = (state) => {
    _store.state = {
        ..._store.state,
        ...state
    };

    setLocalData(_keyStore, _store.state);
    _broadcast();

    return _store.state;
};


// WEBPACK FOOTER //
// ./src/services/AuthServices.js